import {
	UFOExperience,
	ExperienceTypes,
	ExperiencePerformanceTypes,
	untilAll,
} from '@atlassian/ufo';

export const GlobalIssueCreateFromTopNav = new UFOExperience('global-issue-create-from-top-nav', {
	type: ExperienceTypes.Operation,
	performanceType: ExperiencePerformanceTypes.Custom,
	until: untilAll([{ category: 'global-issue-create.create-issue' }]),
});
